module.exports = __webpack_public_path__ + "media/images/athletes/486-b878fb9efa81d2eee6deccc94639d4c1.png";